import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { Router } from '@angular/router';
import { ProviderContext } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { setTimeout } from 'timers';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var jQuery: any;

@Component({
    selector: 'productlist',
    templateUrl: '/templates/get/Product/product_list',
})
export class ProductList implements OnInit {
    public current_row: any;

    public dtx: ProviderContext;
    public providersDtx: ProviderContext;
    public rows: any = [];
    public targetList: any = [];
    public c1List: any = [];
    public c2List: any = [];
    public c3List: any = [];
    public fList: any = [];
    public provList: any = [];

    public c11List: any = [];
    public c22List: any = [];
    public c33List: any = [];

    public funcList: any = [];
    public funcKey: number;
    public funcKeyNew = '';

    public searchText: string;
    public searchTargetText: string;
    public searchProvider = '';
    public searchC1 = '';
    public searchC2: string;
    public searchC3: string;
    public searchF: string; // functional

    public searchC11 = '';
    public searchC22: string;
    public searchC33: string;

    public modalRef: BsModalRef;
    public errstr = '';
    public sourceProd: any;
    public crawlStatusID = '';
    public branded: boolean;
    public isNotAvailable: boolean;
    public isNew: boolean;
    public isOffer: boolean;
    public noFunctionalName: boolean;
    public BioFilter: boolean;
    public GlutFilter: boolean;
    public HuFilter: boolean;
    public LactFilter: boolean;
    public SugFilter: boolean;
    public VegFilter: boolean;
    public NoBrandFilter: boolean;
    public avaliableProductFilter: boolean;
    public NotMatchedFilter: boolean;
    public sourceProdArr: any = [];
    public groupActionVisible: boolean;
    public groupAction: string;
    public isNewFuncKey = false;

    public funcKeyEdit: any = null;
    public funcKeyCurrent: any = null;
    public isExtended: boolean;
    brandInputValue = '';

    @ViewChild('mergetemplate')
    private mergeTemplateRef: TemplateRef<any>;

    @ViewChild('brandtemplate')
    private brandTemplateRef: TemplateRef<any>;
    similarBrandList = [];
    selectedBrand: number;
    selectedProductIdForBrand: number;
    newBrandName: string;

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef,
        private router: Router,
        private http: HttpClient
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: 'PRODUCT',
            SortField: 'LatestActivity',
            IsAsc: false,
        });

        this.providersDtx = new ProviderContext({ ProviderCode: 'PROVIDER', SortField: 'ProviderName' });
        this.providersDtx.addFilter('Available', 'true');
        
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETROOTCATEGORYLIST',
            {},
            (data) => {
                this.c1List = data.TagObject;
                this.c11List = data.TagObject;
            }
        );
        
        this.siteServices.provider_GetAll(
            this.providersDtx,
            (data) => {
                this.provList = data.TagObject;
            }
        );

        this.refresh(true);
    }

    public ngOnInit() {}

    public refresh(needCount: boolean) {
        this.groupActionVisible = false;
        this.groupAction = null;

        this.dtx.FilterList = [];
        this.dtx.addFilter('ProviderID', this.searchProvider);
        this.dtx.addFilter('ProductName', this.searchText);
        if (this.crawlStatusID) {
            this.dtx.addFilter('CrawlStatusID', this.crawlStatusID);
        }
        if (this.branded) {
            this.dtx.addFilter('Branded', '1');
        }
        if (this.isNotAvailable) {
            this.dtx.addFilter('IsNotAvailable', '1');
        }
        if (this.isOffer) {
            this.dtx.addFilter('IsOffer', '1');
        }
        if (this.isNew) {
            this.dtx.addFilter('IsNew', '1');
        }
        if (this.noFunctionalName) {
            this.dtx.addFilter('NoFunctionalName', '1');
        }
        if (this.BioFilter) {
            this.dtx.addFilter('BioFilter', '1');
        }
        if (this.GlutFilter) {
            this.dtx.addFilter('GlutFilter', '1');
        }
        if (this.HuFilter) {
            this.dtx.addFilter('HuFilter', '1');
        }
        if (this.LactFilter) {
            this.dtx.addFilter('LactFilter', '1');
        }
        if (this.SugFilter) {
            this.dtx.addFilter('SugFilter', '1');
        }
        if (this.VegFilter) {
            this.dtx.addFilter('VegFilter', '1');
        }
        if (this.NotMatchedFilter) {
            this.dtx.addFilter('NotMatchedFilter', '1');
        }
        if (this.NoBrandFilter) {
            this.dtx.addFilter('NoBrandFilter', '1');
        }
        if (this.avaliableProductFilter) {
            this.dtx.addFilter('AvaliableProductFilter', '1');
        }

        if (this.searchF) {
            this.dtx.addFilter('FunctionalID', this.searchF);
        } else if (this.searchC3) {
            console.log(this.dtx);
            this.dtx.addFilter('CategoryID', this.searchC3);
        } else if (this.searchC2) {
            this.dtx.addFilter('CategoryGroupID', this.searchC2);
        } else if (this.searchC1) {
            this.dtx.addFilter('CategoryGroupID', this.searchC1);
        }

        this.rows = [];

        this.siteServices.provider_GetPage(this.dtx, (data) => {
            this.rows = data.TagObject;
            this.dtx.TotalItems = data.Tag;
        });
    }

    public chgcat1(ev) {
        const cid = ev.target.value;

        this.c2List = [];
        this.searchC2 = '';
        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c2List = data.TagObject.ChildList;
            }
        );
    }

    public chgcat2(ev) {
        const cid = ev.target.value;

        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c3List = data.TagObject.ChildList;
                if (this.c3List.length === 0) {
                    // LEVÉL - lehet gyneve
                    this.siteServices.provider_Execute(
                        'PRODUCT',
                        'GETFUNCTIONALNAMES',
                        { targetCategory: cid },
                        (data2) => {
                            this.fList = data2.TagObject;
                        }
                    );
                }
            }
        );
    }

    public chgcat3(ev) {
        const cid = ev.target.value;

        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETFUNCTIONALNAMES',
            { targetCategory: cid },
            (data) => {
                this.fList = data.TagObject;
            }
        );
    }

    public chgcat11(ev) {
        const cid = ev.target.value;
        this.c33List = [];
        this.searchC33 = '';
        if (!cid) {
            this.c22List = [];
            this.searchC22 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c22List = data.TagObject.ChildList;
                this.searchC22 = '';
            }
        );
    }

    public chgcat22(ev) {
        const cid = ev.target.value;
        if (!cid) {
            this.c33List = [];
            this.searchC33 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c33List = data.TagObject.ChildList;
                this.searchC33 = '';
            }
        );
    }

    public pageChanged(ev) {
        this.dtx.Page = ev.page;
        this.refresh(false);
    }

    public onSort(_sortField) {
        if (this.dtx.SortField === _sortField) {
            this.dtx.IsAsc = !this.dtx.IsAsc;
        } else {
            this.dtx.SortField = _sortField;
            this.dtx.IsAsc = true;
        }
        this.refresh(false);
    }

    public onSortChange($ev) {
        console.log($ev);
        const arr = $ev.target.value.trim().split(/\s+/);
        this.dtx.SortField = arr[0];
        this.dtx.IsAsc = arr.length === 1;

        this.dtx.SortField2 = arr[2];
        this.dtx.IsAsc2 = arr.length === 1;

        console.log(this.dtx);
        // this.refresh(false);
    }

    public editUser(id) {
        this.router.navigate(['useredit', id]).then((_ev) => {});
    }

    public mergeProduct(sourcep: any) {
        console.log(sourcep);
        this.sourceProd = sourcep;
        this.sourceProdArr = sourcep.ProductName.split(' ');

        this.targetList = [];
        const a = sourcep.ProductName.split(' ');
        this.searchTargetText = a[0] || '';

        if (
            this.searchText &&
            this.searchText
                .toLowerCase()
                .startsWith(this.searchTargetText.toLowerCase())
        ) {
            this.searchTargetText = this.searchText;
        }

        // + (a.length > 1 ? " " + a[1] : "");
        this.modalRef = this.modalService.show(this.mergeTemplateRef, {
            class: 'modal-lg',
        });
        this.searchTargetList();
    }

    public addSearch(token: string) {
        this.searchTargetText += ' ' + token;
    }

    public searchTargetList() {
        const dtx2: ProviderContext = new ProviderContext({
            ProviderCode: 'PRODUCT',
            SortField: 'ProductName',
            IsAsc: true,
            ItemsPerPage: 100000,
        });

        dtx2.addFilter('ProductName', this.searchTargetText);
        // dtx2.addFilter("CategoryID", this.sourceProd.CategoryID);
        dtx2.addFilter('MatchSourceProductID', this.sourceProd.ProductID);
        this.siteServices.inProgress = true;
        this.siteServices.provider_Execute(
            'PRODUCT',
            'FINDMATCHING',
            dtx2,
            (data) => {
                // szürés hasonló bolt
                this.targetList = data.TagObject;
                this.siteServices.inProgress = false;
            }
        );
    }

    public doMerge(targetProd: any) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'MERGE',
            {
                sourceID: this.sourceProd.ProductID,
                targetID: targetProd.ProductID,
            },
            (data) => {
                this.siteServices.success('Összerendelés OK');
                this.modalRef.hide();
                if (this.crawlStatusID === 'SUSPECT') {
                    this.rows.splice(
                        this.rows.findIndex(
                            (x) => x.ProductID === this.sourceProd.ProductID
                        ),
                        1
                    );
                }
                this.refresh(true);
            }
        );
    }

    public doNotMatch() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETCRAWLSTATUS',
            {
                productArr: [this.sourceProd.ProductID],
                crawlStatusID: 'NOTMATCHEDMANUAL',
            },
            (data) => {
                this.siteServices.success('OK');
                this.modalRef.hide();
                if (this.crawlStatusID === 'SUSPECT') {
                    this.rows.splice(
                        this.rows.findIndex(
                            (x) => x.ProductID === this.sourceProd.ProductID
                        ),
                        1
                    );
                }
            }
        );
    }

    public setDoNotMatchGroup() {
        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => y.ProductID);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETCRAWLSTATUS',
            {
                productArr: arr,
                crawlStatusID: 'NOTMATCHEDMANUAL',
            },
            (data) => {
                this.siteServices.success('OK');
                if (this.crawlStatusID === 'SUSPECT') {
                    for (let i = 0; i < arr.length; i++) {
                        this.rows.splice(
                            this.rows.findIndex((x) => x.ProductID === arr[i]),
                            1
                        );
                    }
                }
            }
        );
    }

    public doToggleSelect(prod: any, ev: any) {
        prod._selected = ev.target.checked;

        this.groupActionVisible =
            this.rows.filter((x) => x._selected).length > 0;
        if (!this.groupActionVisible) {
            this.groupAction = null;
        }
    }

    public toggleAll(ev: any) {
        for (const p of this.rows) {
            p._selected = ev.target.checked;
        }

        this.groupActionVisible =
            this.rows.filter((x) => x._selected).length > 0;
        if (!this.groupActionVisible) {
            this.groupAction = null;
        }
    }

    public setGroupCategory() {
        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.ProductID;
            });

        let key = null;

        if (this.searchC33) {
            key = this.searchC33;
        } else if (this.searchC22) {
            key = this.searchC22;
        } else if (this.searchC11) {
            key = this.searchC11;
        }

        if (!key) {
            this.siteServices.error('Nincs célkategória kiválasztva');
            return;
        }

        console.log(arr);
        console.log(key);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETCATEGORY',
            { productArr: arr, targetCategory: key },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Átmozgatás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    public setFunctionalEdit() {
        this.funcKeyEdit = this.funcKeyCurrent;
    }

    public setFunctionalGroup() {
        let catKey = null;
        if (this.searchC3) {
            catKey = this.searchC3;
        } else if (this.searchC2) {
            catKey = this.searchC2;
        }

        if (!catKey) {
            this.siteServices.error(
                'Ez a művelet csak azonos kategóriájú termékekkel hajtható végre, válaszd ki a kategóriaszűrőben'
            );
            return;
        }

        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.ProductID;
            });
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETFUNCTIONALNAMES',
            { productArr: arr, targetCategory: catKey },
            (data) => {
                this.funcList = data.TagObject;
                this.groupAction = 'SETFUNCTIONAL';
                this.isNewFuncKey = false;
                // this.isFuncKeyEdit = false;
                this.funcKeyEdit = null;
                this.funcKeyNew = null;
            }
        );
    }

    public setVerifiedGroup() {
        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.ProductID;
            });
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETVERIFIED',
            { productArr: arr },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Ellenőrizve OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    public setVerified(row) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETVERIFIED',
            { productArr: [row.ProductID] },
            (data) => {
                row.Verified = true;
                // setTimeout(x => { this.siteServices.success("Beállítás OK"); }, 500);
            }
        );
    }

    public setStatusGroup() {
        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => y.ProductID);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETSTATUS',
            { productArr: arr },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Hamarosan átállítva -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    public setStatus(row, state) {
        console.log(row);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETSTATUS',
            { productArr: [row.ProductID] },
            (data) => {
                row.Verified = state;
                this.refresh(true);
                // setTimeout(x => { this.siteServices.success("Beállítás OK"); }, 500);
            }
        );
    }

    public doFunctionalGroup(fkey) {
        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.ProductID;
            });
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETFUNCTIONALNAME',
            { productArr: arr, targetFunctionalID: fkey },
            (data) => {
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success(
                        'Beállítás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    public doFunctionalGroupNew(fkeyname) {
        const arr = this.rows
            .filter((x) => x._selected)
            .map((y) => {
                return y.ProductID;
            });
        this.siteServices.provider_Execute(
            'PRODUCT',
            'ADDFUNCTIONALNAME',
            { productArr: arr, targetFunctionalName: fkeyname },
            (data) => {
                this.doFunctionalGroup(data.TagObject.FunctionalID);
                this.funcList.push(data.TagObject);
            }
        );
    }

    public fetchFuncKey(e) {
        this.funcKeyEdit = null;
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETFUNCTIONALNAMEBYID',
            this.funcKey,
            (data) => {
                this.funcKeyCurrent = data.TagObject;
            }
        );
    }

    public doFunctionalGroupEdit() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'EDITFUNCTIONALNAME',
            this.funcKeyEdit,
            (data) => {
                this.funcKeyEdit = null;
                this.refresh(true);
                setTimeout((x) => {
                    this.siteServices.success('Mentés OK');
                }, 500);
            }
        );
    }

    public delFunctional() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DELFUNCTIONAL',
            this.funcKeyCurrent,
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Törlés OK');
                }, 500);
                this.setFunctionalGroup();
            }
        );
    }

    public doDetails(row: any) {
        // console.log("details" + row.ProductID);
        this.router.navigate(['productedit', row.ProductID]).then((_ev) => {});
    }

    onShowBrand(row: any) {
        row.showBrandInput = true;
        console.log({ productName: row.ProductName });
        row.NewBrand = row.ProductName.split(' ')[0];
    }

    addBrand(newBrand: string, brandID?: number) {
        console.log('addBrand');
        console.log({ newBrand: newBrand, brandID: brandID });
        this.http
            .post<any>(
                '/Provider/AddNewBrand',
                {
                    ProviderCode: 'PRODUCT',
                    BrandName: newBrand,
                    BrandID: brandID,
                    ProductID: this.selectedProductIdForBrand,
                },
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                    }),
                }
            )
            .subscribe((data) => {
                this.refresh(true);
            });
    }

    onCheckSimilar(newBrand: string, ProductId: number) {
        this.selectedProductIdForBrand = ProductId;
        this.newBrandName = newBrand;
        this.http
            .post<any>(
                '/Provider/CheckBrandForSimilar',
                {
                    ProviderCode: 'PRODUCT',
                    Method: 'SIMILARBRAND',
                    Param: newBrand,
                },
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                    }),
                }
            )
            .subscribe((data) => {
                this.similarBrandList = data.TagObject;
                if (data.TagObject && data.TagObject.length === 0) {
                    this.addBrand(newBrand, null);
                } else {
                    this.modalRef = this.modalService.show(
                        this.brandTemplateRef,
                        {
                            class: 'modal-lg',
                        }
                    );
                }
            });
    }

    onUnbranding(row: any) {
        this.http
            .post<any>(
                '/Provider/ProductUnbranding',
                {
                    ProviderCode: 'PRODUCT',
                    Method: 'UNBRANDING',
                    Param: row.ProductID,
                },
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                    }),
                }
            )
            .subscribe((data) => {
                this.refresh(true);
            });
    }
}
